import { render, staticRenderFns } from "./PhysicalApp.vue?vue&type=template&id=09400e0c&"
import script from "./PhysicalApp.vue?vue&type=script&lang=js&"
export * from "./PhysicalApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports